import React, { ReactNode, useState } from 'react';
import { Button } from '@mui/material';
import LinkBehavior from '@/components/LinkBehavior';
import FnfIcon from '@/public/icons/fnf.svg';
import MsIcon from '@/public/icons/ms.svg';
import LoginLoadingIcon from '@/public/icons/loginLoading.svg';
import {
  Container,
  ImageArea,
  LeftLayout,
  StyledHello,
  SpinningIcon,
} from './styles';
import { useRouter } from 'next/router';
import { useMsLoginUrl } from '@/hooks/apiHooks/msAzure';
import { SESSION_KEY_LOGIN_REDIRECT_PATH } from '@/constant/keys';

type P = {
  loadingMode?: boolean;
  error?: ReactNode;
};

const Login = ({ loadingMode, error }: P) => {
  const [logging, setLogging] = useState(loadingMode);
  const router = useRouter();

  const { data, isLoading } = useMsLoginUrl();

  const onClickLogin = () => {
    setLogging(true);
    if (!router.isReady || typeof router.query.redirect !== 'string') return;
    const encodedUrl = encodeURIComponent(router.query.redirect);
    sessionStorage.setItem(SESSION_KEY_LOGIN_REDIRECT_PATH, encodedUrl);
  };

  return (
    <>
      <Container>
        <LeftLayout>
          <FnfIcon />
          <StyledHello>
            반갑습니다.
            <br />
            F&F 포탈에 오신걸 환영합니다.
          </StyledHello>
          <Button
            component={LinkBehavior}
            variant={'outlined'}
            size={'large'}
            href={data?.msAzureLoginUrl}
            target={'_self'}
            loading={isLoading}
            disabled={logging || !data}
            onClick={onClickLogin}
            sx={{
              border: '1px solid #E7E9EC',
              width: '50%',
              fontSize: '14px',
              fontWeight: '500',
              lineHeight: '20px',
              marginTop: '40px',
              paddingTop: '14px',
              paddingBottom: '14px',
              borderRadius: '6px',
              '@media (max-width: 768px)': {
                width: '100%',
                maxWidth: '360px',
              },
            }}
          >
            {logging ? (
              <SpinningIcon>
                <LoginLoadingIcon />
              </SpinningIcon>
            ) : (
              <MsIcon style={{ marginRight: '6px' }} />
            )}
            Microsoft로 로그인
          </Button>
          {error ? (
            error
          ) : (
            <div
              style={{
                color: '#888D96',
                fontSize: '12px',
                marginTop: '8px',
                fontWeight: '400',
              }}
            >
              도움이 필요하신가요?{' '}
              <a
                href={
                  'https://fnf.atlassian.net/servicedesk/customer/portal/50/group/240/create/825'
                }
                style={{ color: '#06C', textDecoration: 'underline' }}
                target={'_blank'}
                rel={'noopener noreferrer'}
              >
                [IT Service]
              </a>
              로 문의해 주세요.
            </div>
          )}
        </LeftLayout>
        <ImageArea>
          <img
            src={'/images/login_background.png'}
            alt={'login background'}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block',
            }}
          />
        </ImageArea>
      </Container>
    </>
  );
};

export default Login;
